import {CustomerCriteria, CustomerIndex, CustomerListItem} from "../../data-access/api-customers/Customer";
import {Injectable} from "@angular/core";
import {Store, StoreConfig} from "@datorama/akita";

export const CUSTOMER_DEFAULT_PAGE_SIZE: number = 20;
export const CUSTOMER_DEFAULT_SORT: string = 'dateUpd,desc';

export function createInitialCustomerCriteria(): CustomerCriteria {
  return {
    term: '',
    enabled: null,
    resident: null,
    residenceId: null,
    type: null,
    page: 0,
    size: CUSTOMER_DEFAULT_PAGE_SIZE,
    sort: CUSTOMER_DEFAULT_SORT,
  };
}

export interface CustomerData {
  /** Page courante de la liste uniquement — la recherche et la pagination sont serveur. */
  customers: CustomerListItem[];
  /**
   * Derniers occupants créés, pour les widgets. Jamais le référentiel complet : mesuré à
   * 620 Ko compressés pour 20 000 fiches, inutilisable sur une connexion dégradée.
   */
  latestCustomers: CustomerIndex[];
  /** Résultats de l'autocomplétion de sélection d'un client (une vingtaine de lignes). */
  selectCustomers: CustomerListItem[];
  customerCriteria: CustomerCriteria;
  customerTotalItems: number;
  customerTotalPage: number;
  error?: unknown;
}

export type CustomerState = CustomerData;

function createInitialState(): CustomerState {
  return {
    customers: [],
    latestCustomers: [],
    selectCustomers: [],
    customerCriteria: createInitialCustomerCriteria(),
    customerTotalItems: 0,
    customerTotalPage: 0,
    error: undefined,
  }
}

@Injectable({
  providedIn: 'root'
})
@StoreConfig({
  name: 'customer'
})
export class CustomerStore extends Store<CustomerState> {
  constructor() {
    super(createInitialState());
  }
}
